const translations = {
    fr: {
      selectVillageLabel: "Sélectionnez votre village",
      selectVillagePlaceholder: "-- Choisir un village --",
      selectParcoursLabel: "Sélectionnez votre parcours",
      selectParcoursPlaceholder: "-- Choisir un parcours --",
      noParcoursAvailable: "Il n'y a actuellement aucun parcours disponible pour le village sélectionné.",
      noLangParcoursAvailable: "Il n'y a actuellement aucun parcours disponible dans votre langue...",
      loadAllParcoursButton: "Afficher tous les parcours",
      startButton: "Démarrer",
      resumeMessage: "Un parcours est déjà en cours.",
      resumeButton: "Reprendre",
      quitButton: "Abandonner",
      quitConfirmationMessage: "Êtes-vous sûr de vouloir abandonner ce parcours ?",
      confirmQuitButton: "Oui, abandonner",
      cancelQuitButton: "Annuler"
    },
    en: {
      selectVillageLabel: "Select your village",
      selectVillagePlaceholder: "-- Choose a village --",
      selectParcoursLabel: "Select your parcours",
      selectParcoursPlaceholder: "-- Choose a parcours --",
      noParcoursAvailable: "There are currently no parcours available for the selected village.",
      noLangParcoursAvailable: "There are currently no tours available in your language...",
      loadAllParcoursButton: "Show all tours",
      startButton: "Start",
      resumeMessage: "A parcours is already in progress.",
      resumeButton: "Resume",
      quitButton: "Quit",
      quitConfirmationMessage: "Are you sure you want to quit this parcours?",
      confirmQuitButton: "Yes, quit",
      cancelQuitButton: "Cancel"
    },
    de: {
      selectVillageLabel: "Wählen Sie Ihr Dorf",
      selectVillagePlaceholder: "-- Dorf wählen --",
      selectParcoursLabel: "Wählen Sie Ihre Route",
      selectParcoursPlaceholder: "-- Route wählen --",
      noParcoursAvailable: "Derzeit sind keine Routen für das ausgewählte Dorf verfügbar.",
      noLangParcoursAvailable: "Zurzeit sind keine Touren in Ihrer Sprache verfügbar...",
      loadAllParcoursButton: "Alle Touren anzeigen",
      startButton: "Starten",
      resumeMessage: "Eine Route ist bereits im Gange.",
      resumeButton: "Fortsetzen",
      quitButton: "Beenden",
      quitConfirmationMessage: "Sind Sie sicher, dass Sie diese Route abbrechen möchten?",
      confirmQuitButton: "Ja, abbrechen",
      cancelQuitButton: "Abbrechen"
    },
    es: {
      selectVillageLabel: "Selecciona tu pueblo",
      selectVillagePlaceholder: "-- Elegir un pueblo --",
      selectParcoursLabel: "Selecciona tu recorrido",
      selectParcoursPlaceholder: "-- Elegir un recorrido --",
      noParcoursAvailable: "Actualmente no hay recorridos disponibles para el pueblo seleccionado.",
      noLangParcoursAvailable: "Actualmente no hay recorridos disponibles en tu idioma...",
      loadAllParcoursButton: "Mostrar todos los recorridos",
      startButton: "Comenzar",
      resumeMessage: "Ya hay un recorrido en curso.",
      resumeButton: "Reanudar",
      quitButton: "Abandonar",
      quitConfirmationMessage: "¿Estás seguro de que quieres abandonar este recorrido?",
      confirmQuitButton: "Sí, abandonar",
      cancelQuitButton: "Cancelar"
    },
    it: {
      selectVillageLabel: "Seleziona il tuo villaggio",
      selectVillagePlaceholder: "-- Scegli un villaggio --",
      selectParcoursLabel: "Seleziona il tuo percorso",
      selectParcoursPlaceholder: "-- Scegli un percorso --",
      noParcoursAvailable: "Attualmente non ci sono percorsi disponibili per il villaggio selezionato.",
      noLangParcoursAvailable: "Attualmente non ci sono percorsi disponibili nella tua lingua...",
      loadAllParcoursButton: "Mostra tutti i percorsi",
      startButton: "Inizia",
      resumeMessage: "Un percorso è già in corso.",
      resumeButton: "Riprendi",
      quitButton: "Abbandona",
      quitConfirmationMessage: "Sei sicuro di voler abbandonare questo percorso?",
      confirmQuitButton: "Sì, abbandona",
      cancelQuitButton: "Annulla"
    }
  };
  
  export default translations;
  